import AssetTypeIcon from './AssetTypeIcon';

export default AssetTypeIcon;
